import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { useInView } from "react-intersection-observer"
import { GridLines, Headline, Eyebrow, Analytics } from "@shared"
import { css, formatSlug, logTool } from "@jsUtils"
import { PageSection } from "../PageSection"

// eslint-disable-next-line no-unused-vars
import Styles from "./worksFeatureScroll.module.scss"

const MOBILE_BREAKPOINT = 1240

const log = logTool()

const convertTitle = str => {
  if (str) {
    return formatSlug(str)
  }
  return ""
}

const Slide = props => {
  const { color, slide, index, children, setFormat, format } = props
  const { title, image, headline } = slide
  const [ref, inView] = useInView({
    threshold: 0.45
  })

  React.useEffect(() => {
    if (inView) {
      setFormat(index)
    }
  }, [inView])
  return (
    <div
      id={convertTitle(slide.title)}
      className={css(
        Styles.slideWrapper,
        index === format && Styles.active,
        index > format && Styles.next,
        index < format && Styles.previous
      )}
      ref={ref}
    >
      <div className={Styles.slide} ref={ref}>
        <div className={Styles.slideContent}>
          <div className={Styles.slideImageWrapper}>
            {image ? (
              <Img className={Styles.slideImage} alt={image.title} fluid={image.fluid} />
            ) : (
              ""
            )}
          </div>
          <div className={Styles.slideCopy}>
            <Eyebrow className={Styles.slideEyebrow} color={color} key="eyebrow">
              Features
            </Eyebrow>
            <Headline className={Styles.slideTitle} color={color} size={3}>
              {`${title}.`}
            </Headline>
            <Headline className={Styles.slideHeadline} size={3}>
              {headline}
            </Headline>
            <p className={Styles.slideBody}>{children}</p>
          </div>
          <Headline className={Styles.slideIndex} size={3} color={color}>
            {`0${index + 1}`}
          </Headline>
        </div>
      </div>
    </div>
  )
}

/**
 * Feature Scroll
 * @param {object} props - React props
 */
// eslint-disable-next-line react/no-multi-comp
const WorksSlides = props => {
  const { theme, color, slides } = props

  const slideThreshold = 1 / slides.length

  const [ref, inView] = useInView({
    threshold: slideThreshold
  })

  const [format, setFormat] = React.useState(0)
  const [mobileLayout, setMobileLayout] = React.useState(false)

  const onResize = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT && !mobileLayout) {
      setMobileLayout(true)
    } else if (window.innerWidth >= MOBILE_BREAKPOINT && mobileLayout) {
      setMobileLayout(false)
    }
  }

  React.useEffect(() => {
    onResize()
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("resize", onResize)
    }
  })

  const slideSections = slides.map((slide, index) => {
    const slideKey = `slide-${slide.id}`
    log(index, slideKey)
    return (
      <Slide
        key={slideKey}
        color={color}
        index={index}
        format={format}
        slide={slide}
        setFormat={setFormat}
        mobileLayout={mobileLayout}
      >
        {slide.description}
      </Slide>
    )
  })

  const Tracked = Analytics("a")

  const indicators = slides.map((slide, index) => {
    return (
      <Tracked
        ascope="LISTS"
        adata={{
          content: slide.title
        }}
        key={`${convertTitle(slide.title)}`}
        href={`#${convertTitle(slide.title)}`}
        onClick={() => {
          const target = document.getElementById(`${convertTitle(slide.title)}`)
          target.scrollIntoView()
        }}
      >
        <Eyebrow
          className={css(Styles.indicator, index === format && Styles.active)}
          color={index === format ? color : "transparent"}
          wrap
          key={`eyebrow-${slide.id}`}
        >
          {slide.title}
        </Eyebrow>
      </Tracked>
    )
  })

  return (
    <PageSection className={Styles.section} theme={theme}>
      <GridLines theme={theme} />
      <div className={css(Styles.wrapper, inView && Styles.inView)}>
        <div className={Styles.mobileIndicators}>
          <Eyebrow className={Styles.eyebrow} color={color} key="eyebrow">
            Features
          </Eyebrow>
        </div>
        <div className={Styles.indicators} data-index={format}>
          {indicators}
        </div>
        <div className={Styles.content} ref={ref}>
          <div>{slideSections}</div>
        </div>
      </div>
    </PageSection>
  )
}

export default WorksSlides
